import React from 'react'
import PropTypes from 'prop-types'
import Slider from 'react-slick'
import Typography from 'components/atoms/Typography'
import breakpoint from 'utils/breakpoints'
import { SVGIcon, Container } from 'components/qstrap'

const Arrow = ({ className, onClick, icon }) => (
  <div className={className} onClick={onClick}>
    <SVGIcon name={icon} size="md" />
  </div>
)

Arrow.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  icon: PropTypes.string,
}

const ThumbnailSlider = ({
  // base
  children,
  title,
  // options
  dots,
  infinite,
  slidesToShow,
  slidesToScroll,
  slidesToShowMd,
  slidesToScrollMd,
  slidesToShowSm,
  slidesToScrollSm,
}) => {
  const settings = {
    dots,
    infinite,
    speed: 500,
    slidesToShow,
    slidesToScroll,
    dotsClass: 'slick-dots',
    nextArrow: <Arrow icon="common-next" />,
    prevArrow: <Arrow icon="common-back" />,
    responsive: [
      {
        breakpoint: breakpoint.sm,
        settings: {
          slidesToShow: slidesToShowSm,
          slidesToScroll: slidesToScrollSm,
          arrows: false,
        },
      },
      {
        breakpoint: breakpoint.md,
        settings: {
          slidesToShow: slidesToShowMd,
          slidesToScroll: slidesToScrollMd,
          arrows: false,
        },
      },
    ],
  }

  return (
    <div className="ThumbnailSlider">
      <Container>
        { title && <Typography variant="title" component="h2" className="thumbnail-slider-title bold">{title}</Typography> }
        <Slider {...settings}>
          {children}
        </Slider>
      </Container>
      <style jsx global>
        {`
          .ThumbnailSlider {
            .slick-track {
              padding: 8px 0;
            }
          }
        `}
      </style>
    </div>
  )
}

ThumbnailSlider.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  dots: PropTypes.bool,
  infinite: PropTypes.bool,
  slidesToShow: PropTypes.number,
  slidesToScroll: PropTypes.number,
  slidesToShowMd: PropTypes.number,
  slidesToScrollMd: PropTypes.number,
  slidesToShowSm: PropTypes.number,
  slidesToScrollSm: PropTypes.number,
}

ThumbnailSlider.defaultProps = {
  dots: false,
  infinite: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  slidesToShowMd: 2.1,
  slidesToScrollMd: 1,
  slidesToShowSm: 1.1,
  slidesToScrollSm: 1,
}

export default ThumbnailSlider
